'use client';

import AnimationContainer from '@/components/Animation/AnimationContainer';
import styles from './animationItem.module.scss';

interface AnimationItemProps {
  isActive: boolean;
  animation: unknown;
  play: boolean;
}

export const AnimationItem = ({
  animation,
  isActive,
  play,
}: AnimationItemProps) => {
  return (
    <li
      className={`${styles.item} ${isActive ? styles.visible : styles.hidden}`}
    >
      <AnimationContainer
        animation={animation}
        isActive={isActive}
        loop
        play={play}
      />
    </li>
  );
};
